<script setup lang="ts">
	import StringMethods from '@/utils/character'

	defineProps<{
		status: string
	}>()

	const { toLower } = StringMethods()
	const activeStatus = [
		'delivered',
		'completed',
		'active',
		'settled',
		'approved',
		'paid',
		'ready',
		'consultation completed'
	]
	const pendingStatus = [
		'pending',
		'waiting',
		'ongoing',
		'fulfillment pending',
		'prescription picked up',
		'follow-up consultation initiated'
	]
	const errorStatus = [
		'rejected',
		'cancelled',
		'failed',
		'unresolved',
		'expired',
		'churned',
		'terminated',
		'cancelled'
	]
	const processingStatus = [
		'unassigned',
		'processing',
		'picked_up',
		'picked up',
		'prescription issued',
		'prescription ready',
		'fulfillment processing',
		'prescription delivered',
		'consultation initiated'
	]
</script>

<template>
	<ui-badge
		class="text-clip px-[14px] py-2 text-[10px]"
		:active="activeStatus.includes(toLower(status))"
		:pending="pendingStatus.includes(toLower(status))"
		:unresolved="errorStatus.includes(toLower(status))"
		:ongoing="processingStatus.includes(toLower(status))"
		:inactive="toLower(status) === 'n/a'"
		:has-default-font="false"
		:has-default-padding="false"
		rounded
	>
		{{ status }}
	</ui-badge>
</template>
